import en from "../locales/en.json";
import pl from "../locales/pl.json";
export var locales = {
    en: en,
    pl: pl,
};
export var defaultLanguage = "en";
